// React Router path definition
// Naming convention = constant-case page container names, e.g. containers/Home uses HOME
export default {
  AVAILABILITY: '/availability',
  CLIENT_ADDITIONAL_INFO: '/clientAdditionalInfo',
  CLIENT_ADDRESS: '/clientAddress',
  CLIENT_CHECKS: '/clientChecks',
  CLIENT_DETAILS: '/clientDetails',
  CLIENT_INFO: '/clientInfo',
  CLIENT_SCORING: '/clientScoring',
  CONTRACT_SIGN: '/contractSign',
  CONTRACT: '/contract',
  CREATE_CIF: '/create_cif',
  EXIT: '/exit',
  FINAL: '/final',
  FINANCE_EMPLOYER: '/financeEmployer',
  FINANCE_EXPENSES: '/financeExpenses',
  FINANCE_INCOME: '/financeIncome',
  FINANCE_PROFESSION: '/financeProfession',
  IDENTITY: '/identity',
  KO_ONLINE: '/koOnline',
  KO_SCORING: '/koScoring',
  LOAN_CONFIGURATOR_RE: '/loanConfiguratorRe',
  LOAN_CONFIGURATOR: '/loanConfigurator',
  NOT_FOUND: '/notFound',
  NOT_IMPLEMENTED_PAGE: '/notImplementedPage',
  OK_BRANCH: '/okBranch',
  PENNY_PAYMENT_CONFIRM: '/pennyPaymentConfirm',
  PENNY_PAYMENT: '/pennyPayment',
  POP_PROCESSING: '/popProcessing',
  POP_UPLOAD: '/popUpload',
  POST_PROCESSING: '/postProcessing',
  PRE_CONTRACT: '/preContract',
  PRINT_CONTRACT: '/printContract',
  PRINT_PRE_CONTRACT: '/printPreContract',
  RECAPITULATION: '/recapitulation',
}
